interface Award {
  title: string;
  organization: string;
  year: number;
}

const AboutSection: React.FC = () => {
  const awards: Award[] = [
    {
      title: "Primer premio XXIX Certamen literario Antonio Sequeros",
      organization: "Ayuntamiento de Almoradí",
      year: 2022
    },
    {
      title: "Accésit XXI Concurso literario \"Vinos de la Mancha\" Lorenzo Serrano",
      organization: "D.O. La Mancha y Diputación de Ciudad Real",
      year: 2023
    },
    {
      title: "Finalista del premio internacional de álbum ilustrado Apila",
      organization: "Apila editorial",
      year: 2021
    }
  ];

  const recognitions = [
    "Proyecto seleccionado dentro de la incubadora cultural ImpulsaCultura Proyecta en Alicante, participando activamente en eventos como el Demo Day Final donde se convergen iniciativas culturales y creativas de la ciudad impulsaculturaproyecta.com.",
    "Mimadre Universe ha sido seleccionada como \"Iniciativa emprendedora con valores\" en Alicante, lo que resalta su carácter inspirador o comprometido desde lo social y cultural"
  ];

  return (
    <section className="about-detailed">
      <div className="about-content">
        <div className="about-section">
          <h2>¿Quién soy?</h2>
          <p>
            Soy Inmaculada Fuentes Tomás, alicantina de nacimiento, de formas y de corazón.
            Nací un 25 de noviembre en Callosa de Segura, al sur de la provincia de Alicante.
          </p>
          <p>
            En mi vida fue muy importante la figura de mi padre. Fue un hombre con gran
            sentido del humor. De él conservo las ganas de reír y el color de los ojos. También
            conservo fotos, su reloj y bonitos recuerdos.
          </p>
          <p>
            Actualmente tengo dos hijos, una hija y un compañero de vida. También tengo un hermano
            y una hermana. Me queda una madre. Me he rodeado siempre de mujeres fuertes y valientes.
            A todas las admiro y de todas aprendo cada día.
          </p>
          <p>
            Me encanta el mar, pasear por la naturaleza, charlar y viajar. Soy mediterránea en el
            fondo y también en las formas. No sabría vivir de otra manera.
          </p>
        </div>

        <div className="about-section">
          <h2>Mi trayectoria</h2>
          <p>
            Estudié Biblioteconomía y Documentación en la Universidad de Murcia. Pasados los años,
            y trabajando en la biblioteca pública municipal de Albatera, realicé la Licenciatura
            en Documentación. En ambos estudios me dieron el Premio Final de Carrera, creo que por
            mi pasión y por mi entrega con lo que hago.
          </p>
          <p>
            Siempre me ha gustado seguir aprendiendo y descubrir cosas nuevas. Quizás soy un alma
            inquieta, quizás me queda todavía mucho por aprender.
          </p>
          <p>
            En mi trabajo diario estoy comprometida con la Cultura y con la Educación. Entre otras
            actividades, realizo programas de animación a la lectura que han sido merecedores de
            premios nacionales como el María Moliner del Ministerio de Cultura español.
          </p>
          <p>
            En el año 2021 fui seleccionada en el programa ImpulsaCultura para la creación de
            Mimadre Universe, una pequeña editorial que pretende ser referente de la creación
            literaria de calidad, educativa, social, solidaria y sostenible.
          </p>
        </div>

        <div className="about-section">
          <h2>Mi pasión</h2>
          <p>
            Decidí estudiar Biblioteconomía porque me encanta la literatura. Admiro en sobremanera
            la capacidad que tienen las personas de decir y de escribir. Para mí, las letras valen
            tanto como las imágenes. Ambas se complementan. Ambas pueden herirte y ambas sanan.
          </p>
          <p>
            Me gusta la Cultura en todas sus formas. Me emociona la música, el teatro, la danza,
            la pintura, la fotografía y cualquier actividad creativa. Casi todas las he practicado
            como aficionada. A todas le dedicaría una vida.
          </p>

          <h3>Reconocimientos literarios:</h3>
          <ul>
            {awards.map((award, index) => (
              <li key={index}>
                <strong>{award.title}</strong> - {award.organization} ({award.year})
              </li>
            ))}
          </ul>

          <h3>Otros reconocimientos:</h3>
          <ul>
            {recognitions.map((recognition, index) => (
              <li key={index}>{recognition}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;